<script setup>
import { ref, computed } from 'vue';
import BaseNotificationsDropdown from '@/layout/base/BaseNotificationsDropdown.vue';

const props = defineProps({
    class: {
        type: String,
        default: ''
    }
});

// Admin-specific notification data
const adminNotificationData = ref({
    inbox: [
        {
            id: 1,
            name: 'System Alert',
            message: 'New site pending approval. Please review the submission and take action.',
            date: '1 hour ago',
            // avatar: '/demo/images/avatar/avatar-square-m-1.jpg',
            action: null
        },
        {
            id: 2,
            name: 'Order Update',
            message: 'Client John Doe has placed a new order for 5 backlinks. Requires verification.',
            date: '2 hours ago',
            // avatar: '/demo/images/avatar/avatar-square-m-2.jpg',
            action: 'confirmation'
        },
        {
            id: 3,
            name: 'Payment Alert',
            message: 'Payment verification required for invoice #1234. Check payment gateway.',
            date: '3 hours ago',
            // avatar: '/demo/images/avatar/avatar-square-f-1.jpg',
            action: 'warn',
            actionText: 'Payment gateway connection may be experiencing issues.'
        }
    ],
    general: [
        {
            id: 4,
            name: 'Server Status',
            message: 'All systems operating normally. Last backup completed successfully.',
            date: '1 day ago',
            // avatar: '/demo/images/avatar/avatar-square-m-1.jpg',
            action: null
        }
    ],
    archived: [
        {
            id: 5,
            name: 'Maintenance',
            message: 'Scheduled maintenance completed. All services restored.',
            date: '2 days ago',
            // avatar: '/demo/images/avatar/avatar-square-f-2.jpg',
            action: null
        }
    ]
});

const handleMarkAllAsRead = () => {
    console.log('Mark all admin notifications as read');
    // Implement admin-specific logic here
};
</script>

<template>
    <BaseNotificationsDropdown
        :class="props.class"
        :data="adminNotificationData"
        title="Admin Notifications"
        :on-mark-all-as-read="handleMarkAllAsRead"
    />
</template>
